import { useEffect, useState } from "react";
import {
  Button,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Loading,
  MaskedInput,
  TextField,
} from "../../../../../components";
import { notification } from "../../../../../services";
import { boletosHelper } from "../../../../../helpers/boletos.helper";

const EnvioWhatsappDialog = ({ open, setOpen, boleto, dadosEmpresa }) => {
  const [loading, setLoading] = useState(false);
  const [celular, setCelular] = useState("");
  const [erroCelular, setErroCelular] = useState(false);
  const [nomeCompletoCliente, setNomeCompletoCliente] = useState("");

  useEffect(() => {
    if (open && boleto.cliente?.id) {
      setCelular(boleto.cliente?.celular);
      setNomeCompletoCliente(boleto.cliente?.nomeRazaoSocial);
    }
  }, [open]);

  const handleInputChange = (event) => {
    setCelular(event.target.value);
  };

  async function enviarMensagem() {
    if (!celular) {
      notification.alertaGenericos("Número de telefone é obrigatório");
      setErroCelular(true);
      return;
    }
    setLoading(true);
    await boletosHelper.enviarMensagem(boleto, celular, dadosEmpresa);
    handleCloseDialog();
  }

  function handleCloseDialog() {
    setLoading(false);
    setNomeCompletoCliente("");
    setCelular("");
    setOpen(false);
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={open}
        onClose={() => handleCloseDialog()}
      >
        <CardHeader title="Envio Whatsapp" className="m-2" />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="nomeCompletoCliente"
                name="nomeCompletoCliente"
                label="Nome"
                variant="filled"
                fullWidth
                value={nomeCompletoCliente}
                disabled
                onChange={(e) => setNomeCompletoCliente(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-user"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MaskedInput
                id="celular"
                name="celular"
                label="Celular"
                mask="(99) 9 9999-9999"
                onChange={handleInputChange}
                margin="none"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <IconButton disabled={true}>
                      <i
                        className="ph-fill ph-device-mobile"
                        style={{ fontSize: 20 }}
                      ></i>
                    </IconButton>
                  ),
                }}
                error={erroCelular}
                value={celular ? celular : ""}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={enviarMensagem}
              >
                Enviar Boleto
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <Loading loading={loading} />
      </Dialog>
    </>
  );
};

export default EnvioWhatsappDialog;
